import DateTime from "../../../../vendor/luxon/src/datetime.js";
import "../../../../vendor/luxon/src/duration.js";
import { useMemo } from "react";
const getMonthCells = (date) => {
  const start = date.startOf("month"), end = date.endOf("month"), dates = [...Array(end.day)].map((_, i) => {
    const date2 = start.plus({ day: i }).toISODate();
    if (!date2) throw new Error("Date is null");
    return {
      content: String(i + 1),
      date: date2,
      id: date2
    };
  });
  return dates.unshift(...Array(start.localWeekday - 1)), dates.push(...Array(7 * 6 - dates.length)), dates;
}, useMonthCells = (date) => useMemo(() => {
  const luxonDate = DateTime.fromISO(date);
  return luxonDate.isValid ? getMonthCells(luxonDate) : [];
}, [date]);
export {
  useMonthCells
};
//# sourceMappingURL=useMonthCells.js.map
